import { Image } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { TruncatedText } from './components';
const IMAGE_SIZE = '28px';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const MetadataTextWrapper = styled.div `
  display: flex;
  flex-direction: column;
  padding-inline-start: ${({ paddingInlineStart }) => paddingInlineStart ? '7px' : 'unset'};
  padding-inline-end: ${({ paddingInlineEnd }) => paddingInlineEnd ? '16px' : 'unset'};
  width: 100%;
  justify-content: center;
`;
const ArtistImage = styled.div `
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 0 0 ${IMAGE_SIZE};
`;
export const Metadata = ({ trackOrAlbumTitle, trackOrAlbumArt, artistName, artistImage, }) => {
    return (React.createElement(Container, { style: { alignItems: 'center' } },
        trackOrAlbumArt && (React.createElement(Image, { src: trackOrAlbumArt, imageHeight: IMAGE_SIZE, imageWidth: IMAGE_SIZE, crop: true, style: { borderRadius: '2px', flex: `0 0 ${IMAGE_SIZE}` } })),
        React.createElement(MetadataTextWrapper, { paddingInlineStart: trackOrAlbumArt !== undefined, paddingInlineEnd: artistImage !== undefined },
            trackOrAlbumTitle && (React.createElement(TruncatedText, { lines: 1, semanticColor: "textBase", variant: "marginalBold" }, trackOrAlbumTitle)),
            artistName && (React.createElement("div", { style: { opacity: 0.7 } },
                React.createElement(TruncatedText, { lines: 1, semanticColor: "textBase", variant: "marginalBold" }, artistName)))),
        artistImage && (React.createElement(ArtistImage, null,
            React.createElement(Image, { src: artistImage, imageHeight: IMAGE_SIZE, imageWidth: IMAGE_SIZE, crop: true, style: { flex: `0 0 ${IMAGE_SIZE}` }, circle: true })))));
};
